var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 0H4.44444C1.98985 0 0 1.54213 0 3.44444C0 5.34676 1.98985 6.88889 4.44444 6.88889H35.5556C38.0102 6.88889 40 5.34676 40 3.44444C40 1.54213 38.0102 0 35.5556 0Z",
    fill: "url(#paint0_linear_1160_344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 12.0557H4.44444C1.98985 12.0557 0 13.5978 0 15.5001C0 17.4024 1.98985 18.9446 4.44444 18.9446H35.5556C38.0102 18.9446 40 17.4024 40 15.5001C40 13.5978 38.0102 12.0557 35.5556 12.0557Z",
    fill: "url(#paint1_linear_1160_344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 24.1113H4.44444C1.98985 24.1113 0 25.6535 0 27.5558C0 29.4581 1.98985 31.0002 4.44444 31.0002H35.5556C38.0102 31.0002 40 29.4581 40 27.5558C40 25.6535 38.0102 24.1113 35.5556 24.1113Z",
    fill: "url(#paint2_linear_1160_344)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1160_344",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 6.88889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481667,
    stopColor: "#FA6409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1160_344",
    x1: 20,
    y1: 12.0557,
    x2: 20,
    y2: 18.9446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481667,
    stopColor: "#FA6409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1160_344",
    x1: 20,
    y1: 24.1113,
    x2: 20,
    y2: 31.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481667,
    stopColor: "#FA6409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.44c422f3d4f5b52b722d5ae5ec004f9b.svg";
export { ForwardRef as ReactComponent };